import React from 'react';
import { window } from '../global';

const TruncatedText = ({ html, limit }) => {
  const tempDiv = window.document.createElement('div');
  tempDiv.innerHTML = html;
  const characters = Array.from(tempDiv.innerText).slice(0, limit);
  return (
    <div style={{ wordWrap: 'break-word' }}>
      {characters.join('')}
      {characters.length === limit && '...'}
    </div>
  );
};

export default TruncatedText;
